// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.txt-color:hover {
    color: blue;
    -webkit-text-decoration: 1px solid blue;
            text-decoration: 1px solid blue;
}
.footer-bg-color {
    background-color: rgb(236, 234, 232);
    border-top: 1px solid rgba(0, 0, 0, 0.158);
}
.grid-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px; /* Adds a 30px gap between rows and columns */
}
@media screen and (min-width: 768px) {
    .gone-layout-lg {
        display: none;
    }
    .txt-color{
        height: 30px;
        color: #5a4d4d;
        text-decoration: none;
    }
}
@media screen and (min-width: 992px) {
    .center-width {
        width: 80%;
    }
}
@media screen and (max-width: 768px) {  
    .gone-layout-sm{
        display: none;
    }
    .txt-color{
        color: #5a4d4d;
        text-decoration: none;
        margin: 3px;
    }
}
@media screen and (max-width: 500px) {
    .colorixlogo{
        width: 100px;
        height:30px;
    }
}

@media screen and (min-width: 500px) and (max-width: 800px) {
    .colorixlogo{
        width: 140px;
        height:40px;
        margin-top:-9px;
    }

}

@media screen and (min-width: 800px) and (max-width: 1200px) {
    .colorixlogo{
        width: 160px;
        height:45px;
        margin-top:-13px;
    }
    
}

@media screen and (min-width: 1200px){
    .colorixlogo{
        width: 190px;
        height:55px;
        margin-top:-16px;
    }
        
}`, "",{"version":3,"sources":["webpack://./src/components/style/FooterComponent.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,uCAA+B;YAA/B,+BAA+B;AACnC;AACA;IACI,oCAAoC;IACpC,0CAA0C;AAC9C;AACA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS,EAAE,6CAA6C;AAC5D;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,YAAY;QACZ,cAAc;QACd,qBAAqB;IACzB;AACJ;AACA;IACI;QACI,UAAU;IACd;AACJ;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,cAAc;QACd,qBAAqB;QACrB,WAAW;IACf;AACJ;AACA;IACI;QACI,YAAY;QACZ,WAAW;IACf;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,WAAW;QACX,eAAe;IACnB;;AAEJ;;AAEA;IACI;QACI,YAAY;QACZ,WAAW;QACX,gBAAgB;IACpB;;AAEJ;;AAEA;IACI;QACI,YAAY;QACZ,WAAW;QACX,gBAAgB;IACpB;;AAEJ","sourcesContent":[".txt-color:hover {\n    color: blue;\n    text-decoration: 1px solid blue;\n}\n.footer-bg-color {\n    background-color: rgb(236, 234, 232);\n    border-top: 1px solid rgba(0, 0, 0, 0.158);\n}\n.grid-container {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 20px; /* Adds a 30px gap between rows and columns */\n}\n@media screen and (min-width: 768px) {\n    .gone-layout-lg {\n        display: none;\n    }\n    .txt-color{\n        height: 30px;\n        color: #5a4d4d;\n        text-decoration: none;\n    }\n}\n@media screen and (min-width: 992px) {\n    .center-width {\n        width: 80%;\n    }\n}\n@media screen and (max-width: 768px) {  \n    .gone-layout-sm{\n        display: none;\n    }\n    .txt-color{\n        color: #5a4d4d;\n        text-decoration: none;\n        margin: 3px;\n    }\n}\n@media screen and (max-width: 500px) {\n    .colorixlogo{\n        width: 100px;\n        height:30px;\n    }\n}\n\n@media screen and (min-width: 500px) and (max-width: 800px) {\n    .colorixlogo{\n        width: 140px;\n        height:40px;\n        margin-top:-9px;\n    }\n\n}\n\n@media screen and (min-width: 800px) and (max-width: 1200px) {\n    .colorixlogo{\n        width: 160px;\n        height:45px;\n        margin-top:-13px;\n    }\n    \n}\n\n@media screen and (min-width: 1200px){\n    .colorixlogo{\n        width: 190px;\n        height:55px;\n        margin-top:-16px;\n    }\n        \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
